module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_count_rank/3_14f44a9afee78f988d502077beeb09a4.png";